var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00184 1H1M8.00184 7.2069H1M17 13H1",
    stroke: "#0C208F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9370_2357)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.6667,
    cy: 4.66667,
    r: 4.16667,
    stroke: "#0C208F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2079,
    y: 9.06165,
    width: 1.18289,
    height: 5.91248,
    rx: 0.591444,
    transform: "rotate(-46.1764 17.2079 9.06165)",
    stroke: "#0C208F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9370_2357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSearch);
export default __webpack_public_path__ + "static/media/menu-search.2e67247014ce4a4c5d6450cb6e537558.svg";
export { ForwardRef as ReactComponent };